<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on }">
      <v-btn color="red" fab small dark v-on="on"
        ><v-icon style="font-size: 26px;">lock_reset</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title
        class="headline"
        style="background-color: #303F9F; color:#fff;"
        >Reset Password
        <v-spacer></v-spacer>
        <v-btn color="red" fab small dark @click="clearData()"
          ><v-icon>close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-text-field
              v-model="password"
              label="New Password"
              prepend-inner-icon="key"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12>
            <v-text-field
              v-model="C_password"
              label="Confirm Password"
              prepend-inner-icon="key"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="indigo"
          style="color:#fff; margin-left:38%;"
          @click="submitResetPass()"
          >Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["college_code"],
  data() {
    return {
      dialog: false,
      password: "",
      C_password: "",
    };
  },

  methods: {
    submitResetPass() {
      let peram = {
        password: this.password,
        college_code: this.college_code,
      };
      if (this.C_password && this.password == this.C_password) {
        console.log("Tanvir! this is reset data", peram);
        this.$store.dispatch("resetColPass", peram).then((data) => {
          this.password = "";
          this.C_password = "";
          this.dialog = false;
        });
      }
    },
    clearData() {
      this.password = "";
      this.C_password = "";
      this.dialog = false;
    },
  },
};
</script>
<style lang=""></style>
